import { B } from "../../design/tokens";

export default function IsabelBubble({ role, text }) {
  const isAssistant = role === "assistant";
  return (
    <div style={{ display: "flex", justifyContent: isAssistant ? "flex-start" : "flex-end" }}>
      <div style={{
        maxWidth: "82%",
        background: isAssistant ? B.white : `linear-gradient(135deg, ${B.azure} 0%, ${B.royal} 100%)`,
        color: isAssistant ? B.slate : B.white,
        border: isAssistant ? `1px solid ${B.border}` : "none",
        borderRadius: isAssistant ? "16px 16px 16px 4px" : "16px 16px 4px 16px",
        padding: "10px 14px",
        fontFamily: "'Space Grotesk', sans-serif",
        fontSize: 13.5,
        lineHeight: 1.6,
        boxShadow: isAssistant ? `0 1px 4px ${B.ink}11` : `0 2px 10px ${B.azure}33`,
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
      }}>
        {text}
      </div>
    </div>
  );
}
